import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import * as api from '../api/codigos-qr'
import type { CodigoQRIn, CodigoQRUpdate } from '../types'

const QK = 'codigos-qr'

export function useCodigosQR(params?: { page?: number; page_size?: number; search?: string }) {
  return useQuery({
    queryKey: [QK, params],
    queryFn: () => api.getCodigosQR(params),
  })
}

export function useCreateCodigoQR() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: CodigoQRIn) => api.createCodigoQR(payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: [QK] }),
  })
}

export function useUpdateCodigoQR() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: CodigoQRUpdate }) =>
      api.updateCodigoQR(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: [QK] }),
  })
}

export function useDeleteCodigoQR() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => api.deleteCodigoQR(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: [QK] }),
  })
}
